const numbers = require('./numbers');
const lowercase = require('./lowercase');
const uppercase = require('./uppercase');

module.exports = numbers + lowercase + uppercase;
